// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-state-banner_container__2yC1F","icon":"empty-state-banner_icon__3mSId","text":"empty-state-banner_text__O8zsb","link":"empty-state-banner_link__2cvBu"};